// src/date/duration.ts
var breakdownDurationToUnits = ({
  from,
  to,
  units = ["year", "month", "day", "hour", "minute", "second"],
  includeZero
}) => {
  const timeTo = to || /* @__PURE__ */ new Date();
  const diff = (timeTo.getTime() - from.getTime()) / 1e3;
  let year = 0;
  let month = 0;
  let day = 0;
  let hour = 0;
  let minute = 0;
  let second = 0;
  const includeYear = units.includes("year");
  if (includeYear) {
    year = Math.floor(diff / (365 * 24 * 60 * 60));
  }
  const includeMonth = units.includes("month");
  if (includeMonth) {
    const fullMonth = includeYear;
    month = fullMonth ? Math.floor(diff % (365 * 24 * 60 * 60) / (30 * 24 * 60 * 60)) : Math.floor(diff / (30 * 24 * 60 * 60));
  }
  const includeDay = units.includes("day");
  if (includeDay) {
    const fullDay = !includeYear && !includeMonth;
    day = fullDay ? Math.floor(diff / (24 * 60 * 60)) : Math.floor(diff % (30 * 24 * 60 * 60) / (24 * 60 * 60));
  }
  const includeHour = units.includes("hour");
  if (includeHour) {
    const fullHour = !includeYear && !includeMonth && !includeDay;
    hour = fullHour ? Math.floor(diff / (60 * 60)) : Math.floor(diff % (24 * 60 * 60) / (60 * 60));
  }
  const includeMinute = units.includes("minute");
  if (includeMinute) {
    const fullMinute = !includeYear && !includeMonth && !includeDay && !includeHour;
    minute = fullMinute ? Math.floor(diff / 60) : Math.floor(diff % (60 * 60) / 60);
  }
  const includeSecond = units.includes("second");
  if (includeSecond) {
    const fullSecond = !includeYear && !includeMonth && !includeDay && !includeHour && !includeMinute;
    second = fullSecond ? Math.floor(diff) : Math.floor(diff % 60);
  }
  const result = { year, month, day, hour, minute, second };
  if (includeZero) {
    return result;
  }
  const noZeros = {};
  for (const unit of units) {
    if (result[unit] > 0) {
      noZeros[unit] = result[unit];
    }
  }
  return noZeros;
};
var formatDuration = ({
  from,
  to,
  locale = "en",
  units = ["year", "month", "day", "hour", "minute", "second"],
  options,
  delimiter = " "
}) => {
  const rtf = new Intl.RelativeTimeFormat(locale, options);
  const isRTL = locale.startsWith("ar");
  const formatted = [];
  const breakdown = breakdownDurationToUnits({ from, to, units });
  const keys = Object.keys(breakdown);
  const lastUnit = keys[keys.length - 1];
  let index = 0;
  for (const unit of keys) {
    const value = Number(breakdown[unit]);
    const duration = rtf.format(-value, unit);
    const shouldTrim = isRTL ? index > 0 : unit !== lastUnit;
    let cleanVal = duration;
    if (shouldTrim) {
      const durationParts = duration.split(" ");
      cleanVal = isRTL ? durationParts.slice(1).join(" ") : durationParts.slice(0, -1).join(" ");
      formatted.push(cleanVal);
    } else {
      formatted.push(duration);
    }
    index++;
  }
  return formatted.join(delimiter);
};

export {
  breakdownDurationToUnits,
  formatDuration
};
//# sourceMappingURL=chunk-45F5WRGE.mjs.map